<template>
<div class="d-flex fullHeight">
    <HelppageSideMenu @set="initialize" class="d-sm-block d-none"/>
    <div class="mainContent mainwindow">
        <div class="p-2">
            <div class="pageTitles">よくある質問</div>
            <div class="cardwindow mt-3 mb-4">
                <div class="accentHelp">
                    <h5 class="font-weight-bold mb-4">パスワードを忘れた場合</h5>
                    <div class="border">
                        <div class="menu">
                            <input id="acd-check1" class="acd-check" type="checkbox">
                            <label class="acd-label" for="acd-check1"><a class="acd-label-hover">Q．パスワードを忘れました。</a></label>
                            <div class="acd-content">       
                                <p>登録情報変更の手順は以下の通りです。<br>
                                1. ログイン画面で「※パスワードを忘れた方はこちら」をクリックします。<br>
                                2. メールアドレスとお名前を入力後「パスワード再設定」をクリックすると「パスワード再設定受付」メールが送信されます。<br>
                                3.「パスワード再設定受付」メールのリンクをクリックし、パスワード再設定画面に移動してください。<br>
                                4. 新しいパスワード、新しいパスワード（確認）を入力して「パスワードを登録する」をクリックしてください。<br>
                                5. パスワード再設定完了画面に移動します。<br>
                                6. 完了です。<br></p>
                            </div>
                        </div>
                    </div>
                    <div class="border">
                        <div class="menu">
                            <input id="acd-check2" class="acd-check" type="checkbox">
                            <label class="acd-label" for="acd-check2"><a class="acd-label-hover">Q．パスワードを忘れ、登録時とメールアドレスが変わっているので、パスワード再発行ができません。</a></label>
                                <div class="acd-content">
                                    <p>
                                        お手数ですが下記宛にお問い合わせください。
                                    </p>
                                    <a :href="`mailto:${info_mail}`">{{ info_mail }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <HelppageSideMenu @set="initialize" class="d-sm-none"/>
        </div>
    </div>
</div>
</template>


<script>
import HelppageSideMenu from './HelppageSideMenu';
import HelpMenuItem from './components/HelpMenuItem';

export default {
components: {
        HelppageSideMenu,
        HelpMenuItem
    },
    data(){
        return {
            info_mail: process.env.MIX_SUPPORT_MAILADDRESS
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        SigninForm() {
            this.$router.push("/");
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
        }
    }
}
</script>
